export enum TipoImportacaoEnum {

  txt_giss,
  xls,
  xml_gov,
  xml_sefaz,
  errado
}
